export default function ({ store, route }) {
    const { fullPath } = route;
    const canonicalMainLink = process.env.baseUrl + fullPath;

    store.dispatch('addLinkToHead', {
        rel: 'canonical',
        href: canonicalMainLink,
    });
}
